var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 18,
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 0.666748H7.50004C6.39497 0.666748 5.33516 1.10573 4.55376 1.88714C3.77236 2.66854 3.33337 3.72835 3.33337 4.83341V7.33341H0.833374V10.6667H3.33337V17.3334H6.66671V10.6667H9.16671L10 7.33341H6.66671V4.83341C6.66671 4.6124 6.75451 4.40044 6.91079 4.24416C7.06707 4.08788 7.27903 4.00008 7.50004 4.00008H10V0.666748Z",
    fill: "#07070C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.5bdb638f4db2c0d56b1881e428cd385a.svg";
export { ForwardRef as ReactComponent };